module.exports = __webpack_public_path__ + "img/setting-2.585d9916.svg";